import { lazy } from 'react';

export const TermsOfServiceEmbededPageAsync = lazy(
    () => import('./TermsOfServiceEmbededPage'),
);
